import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import { trackLLMSourceAcquisition } from 'helpers/utils/llmSourceTracking';

/**
 * Custom hook to track LLM platform acquisition
 * Fetches llmReferrerConfig from remote config and tracks the source
 */
const useLLMSourceTracking = (): void => {
  const llmReferrerConfig = useSelector(
    (state: State) => state.remoteConfig.configs?.llmReferrerConfig
  );

  useEffect(() => {
    // Check if feature is enabled before tracking
    if (!llmReferrerConfig?.enabled) return;

    trackLLMSourceAcquisition(llmReferrerConfig.patterns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useLLMSourceTracking;
